module.exports = __webpack_public_path__ + "static/media/mail_gray.ddb4df44.svg";